var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-23.2%",
    y: "-30.4%",
    width: "160.7%",
    height: "160.7%",
    filterUnits: "objectBoundingBox",
    id: "bs54r2gxia"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.788235294 0 0 0 0 0.788235294 0 0 0 0 0.788235294 0 0 0 0.22 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.268 6.268 0 14 0s14 6.268 14 14-6.268 14-14 14S0 21.732 0 14z",
    id: "e7edpv0lob"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 5)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#bs54r2gxia)",
    xlinkHref: "#e7edpv0lob"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#e7edpv0lob"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#272726",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.082 19.001-4.163 4.162M19.082 19l-4.163-4.163"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoArrow);
export default __webpack_public_path__ + "static/media/go-arrow.3d5d4184673734e73d5b8951c519acc7.svg";
export { ForwardRef as ReactComponent };